import { useEffect } from 'react';
import { LocalStore } from 'constants/localstore';
import { useLocation } from 'components/_hooks/use-router';
import { AppProtected } from './app-protected';

export const AppRedirect = () => {
  const { path, search } = useLocation();

  useEffect(() => {
    localStorage.setItem(LocalStore.redirect, path + search);
  }, []);

  return <AppProtected />;
};
